<template>
  <div id="app">
    <header class="navbar bg-primary-500">
      <div class="container-custom">
        <nav class="flex justify-between items-center">
          <router-link to="/" class="flex items-center">
            <!-- 网站Logo -->
            <div class="w-12 h-12 rounded-full bg-white text-primary-500 flex items-center justify-center mr-3 shadow-primary">
              <span class="text-2xl font-bold">?</span>
            </div>
            <h1 class="text-2xl font-display text-white hover:text-primary-100 transition-colors">小朋友奇思妙问</h1>
          </router-link>
          <div class="flex space-x-3">
            <router-link to="/" class="btn bg-white text-primary-500 hover:bg-primary-50">首页</router-link>
            <router-link to="/timeline" class="btn bg-white text-primary-500 hover:bg-primary-50">历史时间线</router-link>
          </div>
        </nav>
      </div>
    </header>

    <main class="container-custom py-8">
      <router-view/>
    </main>

    <footer class="footer bg-primary-50">
      <div class="container-custom text-center">
        <p class="text-gray-600">&copy; {{ new Date().getFullYear() }} 小朋友奇思妙问 - 记录孩子们的好奇心</p>
        <div class="mt-4 flex justify-center space-x-4">
          <span class="tag tag-primary hover-wiggle">自然科学</span>
          <span class="tag tag-secondary hover-wiggle">历史</span>
          <span class="tag tag-accent hover-wiggle">生活</span>
          <span class="tag tag-fun hover-wiggle">太空</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Arial', sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 头部样式 */
header {
  background-color: #4caf50;
  color: white;
  padding: 20px 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

header h1 {
  font-size: 28px;
}

header nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 按钮样式 */
.btn {
  display: inline-block;
  background-color: #4caf50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  transition: background-color 0.3s;
}

.btn:hover {
  background-color: #388e3c;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #4caf50;
  color: #4caf50;
}

.btn-outline:hover {
  background-color: #4caf50;
  color: white;
}

/* 问题列表样式 */
.question-list {
  margin: 30px 0;
}

.question-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
  transition: transform 0.3s;
}

.question-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.question-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #333;
}

.question-title a {
  color: #333;
  text-decoration: none;
}

.question-title a:hover {
  color: #4caf50;
}

.question-meta {
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
}

.question-category {
  display: inline-block;
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 10px;
}

/* 问题详情页样式 */
.question-detail {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin: 30px 0;
}

.question-content {
  margin: 20px 0;
  line-height: 1.8;
}

.answer-list {
  margin-top: 30px;
}

.answer-card {
  background-color: #f8f9fa;
  border-left: 4px solid #4caf50;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 0 4px 4px 0;
}

.answer-content {
  margin: 10px 0;
  line-height: 1.7;
}

.answer-meta {
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 14px;
}

/* 分页控件样式 */
.pagination {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

.pagination button {
  background-color: white;
  border: 1px solid #ddd;
  padding: 8px 15px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.pagination button:hover {
  background-color: #f1f1f1;
}

.pagination button.active {
  background-color: #4caf50;
  color: white;
  border-color: #4caf50;
}

/* 筛选器样式 */
.filter-section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 30px;
}

.filter-title {
  font-size: 18px;
  margin-bottom: 15px;
}

.category-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.category-filter {
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 5px 10px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.category-filter:hover, .category-filter.active {
  background-color: #2e7d32;
  color: white;
}

/* 回答表单样式 */
.answer-form {
  margin-top: 40px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
}

.form-group input, .form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.form-group textarea {
  min-height: 150px;
  resize: vertical;
}

/* 页脚样式 */
footer {
  background-color: #f1f1f1;
  padding: 20px 0;
  margin-top: 40px;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  header nav {
    flex-direction: column;
    align-items: flex-start;
  }
  
  header h1 {
    margin-bottom: 10px;
  }
  
  .question-meta {
    flex-direction: column;
    gap: 5px;
  }
}
</style> 